import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { IRecruiterTeamNameAutoCompleteOption, usersAdvanceFilterQuery } from 'wisestep-api';
import { WsAutoComplete } from 'wisestep-base';

import {
  getRecruiterNameAndEmail,
  transformIRecruiterTeamNameOptionsToStringArray,
  getFilterObj,
  getRecruiterEmails,
} from '../../../features/jobs/helper';
interface RecruiterSuggestionsProps {
  name: string;
  multiple?: boolean;
  defaultValue?: string[];
  placeholder?: string;
  focused?: boolean;
  requireRecruiter?: boolean;
  disabled?: boolean;
  value?: string | string[];
  required?: boolean;
  onSelectMultipleValues?: (emails: string[]) => void;
  displayOnlyName?: boolean;
  disableAutoComplete?: boolean;
}

const RecruiterSuggestions = ({
  name,
  multiple,
  placeholder = 'Eg,Michael',
  defaultValue = [],
  focused = false,
  requireRecruiter = false,
  disabled = false,
  value,
  required = false,
  onSelectMultipleValues,
  displayOnlyName,
  disableAutoComplete = false,
}: RecruiterSuggestionsProps) => {
  const { setValue } = useFormContext();
  const [recruiters, setRecruiters] = useState<string[]>([]);

  const [recruitersSuperList, setRecruitersSuperList] = useState<
    IRecruiterTeamNameAutoCompleteOption[]
  >([]);

  const onRecruitersSelection = (recruiters: string[]) => {
    if (!requireRecruiter) {
      const recruitersEmails = getRecruiterEmails(recruitersSuperList, recruiters);
      setValue(name, recruitersEmails);
      onSelectMultipleValues && onSelectMultipleValues(recruitersEmails);
    } else {
      setValue(name, getFilterObj(recruitersSuperList, recruiters)[0]);
    }
  };

  const onRecruiterInputKey = async (accountManagerPrefix: string) => {
    const response = await usersAdvanceFilterQuery(accountManagerPrefix);
    const result = getRecruiterNameAndEmail(response.data);
    setRecruitersSuperList((prev) => prev.concat(result));

    const recTeamNameEmails: string[] = displayOnlyName
      ? result.map((item) => {
          const namePart = item.text.split(' (')[0];
          return namePart;
        })
      : transformIRecruiterTeamNameOptionsToStringArray(result);

    setRecruiters(recTeamNameEmails);
  };
  return (
    <WsAutoComplete
      onValueEnter={onRecruiterInputKey}
      onTagsChange={onRecruitersSelection}
      placeholder={placeholder}
      initialValue={defaultValue}
      optionsInStringArray={recruiters}
      multiple={multiple}
      freeSolo={false}
      name={name}
      size="small"
      focused={focused}
      disabled={disabled}
      disableAutoComplete={disableAutoComplete}
      value={value}
      required={required}
    />
  );
};
export default RecruiterSuggestions;
